import React, { Fragment } from 'react';

import get from 'lodash/get';
import map from 'lodash/map';
import find from 'lodash/find';
import takeWhile from 'lodash/takeWhile';

import THEME_STYLESHEET_VERSIONS from './theme_stylesheet_versions.json';

import {
  ACCESSIBILITY_DESCRIPTION
} from '../sites_const_shared/accessibility.js';

export const ALL_THEME_STYLESHEET_VERSIONS = map(THEME_STYLESHEET_VERSIONS, 'version');
export const LATEST_THEME_STYLESHEET_VERSION = get(find(THEME_STYLESHEET_VERSIONS, ['isLatest', true]), 'version');

export const THEME_STYLESHEET_V1 = 'v1';
export const THEME_STYLESHEET_V2 = 'v2';
export const THEME_STYLESHEET_V3 = 'v3';
export const THEME_STYLESHEET_V4 = 'v4';

// ordering wasn't considered in the original version so we need to keep track
// of it here for compatibility determination
export const ORDERED_THEME_STYLESHEET_VERSIONS = [
  THEME_STYLESHEET_V1,
  THEME_STYLESHEET_V2,
  THEME_STYLESHEET_V3,
  THEME_STYLESHEET_V4
];

export const getPreviousThemeStylesheetVersions = (currentStylesheetVersion)=> {
  return takeWhile(ORDERED_THEME_STYLESHEET_VERSIONS, (version)=> {
    return version !== currentStylesheetVersion;
  });
};

// previous versions won't matter so we only need descriptions for the most
// recent upgrade available
export const MostRecentStylesheetUpgradeDescription = ()=> (
  <Fragment>
    <p>
      A stylesheet upgrade is available that will enable you to create
      accessible sites with this theme.
    </p>

    <p>
      { ACCESSIBILITY_DESCRIPTION }
    </p>

    <p>
      After upgrading, you should check that there are no issues with the sites
      that use this theme, before publishing to any live sites.
    </p>
  </Fragment>
);
